import React, { FC, useEffect, useMemo, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import {
    fetchData,
    findMenuWithParent,
    formatDate,
    getEncryptedRoute,
    toasterrormsg,
    toastsuccessmsg,
    useMenuIdPermissions,
} from '../../../../reusable'
import Swal from 'sweetalert2'
import { ToastContainer } from 'react-toastify'
import DataTable from 'react-data-table-component'
import { Tr } from '../../../../_metronic/i18n/Tr'
import { KTIcon } from '../../../../_metronic/helpers'
import Loader from '../../components/Loader'
import { useMenuContext } from '../../contexts/MenuContext'


const ReportedUsers: FC = () => {
    let t = Tr()
       const tmp = sessionStorage.getItem('admin')
const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''

    const { menuId, menuIdEdit, menuIdDelete, menuIdView } = useMenuIdPermissions()
      const { fullMenu } = useMenuContext()
    const result = findMenuWithParent(fullMenu, "../postmanagement/");
    const postManagementId = result?.menu?.menuId

    const [reportedUserList, setReportedUserList] = useState([])
    const [searchTerm, setSearchTerm] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [totalRecords, setTotalRecords] = useState(0)
    const [limit, setLimit] = useState(10)
    const [offset, setOffset] = useState(0)
    const [sortField, setSortField] = useState('')
    const [sortOrder, setSortOrder] = useState('')
    const [isDataLoaded, setIsDataLoaded] = useState(false)
    const [focus, setFocus] = useState('')
    


    const reportedUserListApiCall = async () => {
        try {
            if (!isDataLoaded) {

                setIsLoading(true)
            }
            const param = {
                limit: limit,
                offset: offset,
                term: searchTerm.trim(),
                sortBy: sortField,
                sort: sortOrder
            }
            const response = await fetchData('admin/explore/user/report/list', param)

            if (response.status == '200') {
                const data = response.data
                setTotalRecords(data.totalRecord || 0)
                setReportedUserList(data.list || [])
                setIsDataLoaded(true)
            } else {
                toasterrormsg(response.message)
                setReportedUserList([])
                setTotalRecords(0)
            }
        } catch (error) {
            console.error('Error fetching reported user list:', error)
            toasterrormsg('Failed to fetch reported user')
            setReportedUserList([])
            setTotalRecords(0)
        } finally {
            setIsLoading(false)
        }
    }

    const changeReportUserStatus = async (action: string | number, userId: number, reportedBy: string, reportReason: string) => {
        let swalOptions: any = {
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
        }

        if (action == '1') {
            swalOptions = {
                ...swalOptions,
                title: t('Are you sure you want to suspend this user?'),

            }
        }
        if (action == '0') {
            swalOptions.title = t('Are you sure you want to activate this user?')
        }

        const result = await Swal.fire(swalOptions)
        if (!result.isConfirmed) return

        const param: any = {
            userId,
            status: action,
            adminId: adminId,
            reportedBy: reportedBy,
            reportReason: reportReason,
        }


        try {
            setIsLoading(true)
            const response = await fetchData('admin/explore/suspend/user', param)

            if (String(response?.status) === '200') {
                reportedUserListApiCall()
                toastsuccessmsg(response.message)
            } else {
                toasterrormsg(response?.message || 'Action failed')
            }
        } catch (error) {
            toasterrormsg( 'Action failed')
            
        } finally {
            setIsLoading(false)
        }
    }
    const reportedUserSearch = (text: string, isfoc: any) => {
        setSearchTerm(text)
        setFocus(isfoc)

        setOffset(0)
    }

    const handleSort = (column: any, sortDirection: string) => {
        try {
            const fieldName = column.selector ? String(column.selector).split('.').pop() : ''
            setSortField(fieldName || '')
            setSortOrder(sortDirection === 'asc' ? 'asc' : 'desc')
        } catch (error) {
            console.error('Error in sorting:', error)
        }
    }


    const CustomHeader = (props: any) => {
        const inputRef: any = useRef(null)

        // Define the onchange event handler
        const handleChange = async (e: any) => {
            // Focus on the input element when the onchange event is triggered
            await props.customSearch(e, 1)
        }
        useEffect(() => {
            // Check if the ref exists and if the component should be focused
            if (inputRef.current && props.isfoc === 1) {
                inputRef.current.focus()
            }
        }, [props.isfoc])

        return (
            <div className=' d-flex justify-content-between w-100 my-5'>
                <div className='d-flex align-items-center position-relative my-1 '>
                    <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
                    <input
                        type='text'
                        data-kt-user-table-filter='search'
                        className='form-control form-control-solid w-250px ps-14'
                        placeholder={t('Search...')}
                        value={props.search}
                        onChange={(e: any) => handleChange(e.target.value)}
                        ref={inputRef}
                    />
                </div>

            </div>
        )
    }

    const column = useMemo(
        () => [
            {
                name: t('Reported By'),
                cell: (row: any) => (
                    <div className='my-3'>
                        <div className='fw-bold fs-5'>{row.reporterName || '-'}</div>
                    </div>
                ),
                sortable: true,
                selector: (row: any) => row.reporterName,
                width: "250px"
            },
            {
                name: t('Reported User'),
                cell: (row: any) => (
                    <div className='my-3'>
                        <div className='fw-bold fs-5'>{row.reportedName || '-'}</div>
                    </div>
                ),
                sortable: true,
                selector: (row: any) => row.reportedName,
                width: "250px"
            },
            {
                name: t('Report Reason'),
                cell: (row: any) => (
                    <div className='my-3'>
                        <div className='fw-bold fs-5'>{row.reason || '-'}</div>
                    </div>
                ),
                sortable: false,
                selector: (row: any) => row.reason,
                width: "350px"

            },

            {
                name: t('Reported At'),
                cell: (row: any) => (
                    <div className='my-3'>
                        <div className='fw-bold fs-5'>{formatDate(row.created, 'DD-MM-YYYY') || '-'}</div>
                    </div>
                ),
                sortable: true,
                selector: (row: any) => row.created,
                                width: "130px"

            },
            {
                name: t('Action'),
                cell: (row: any) => (
                    <div className='d-flex gap-2'>


                        {menuIdEdit && (
                            <>
                                {row.status == "0" && <button
                                    className="btn btn-light-danger btn-sm d-flex align-items-center  px-3 py-2 rounded-pill shadow-sm"
                                    title="Suspend User "
                                    onClick={() => changeReportUserStatus('1', row.reportedId, row.reporterName || '', row.reason || '')}
                                >
                                    <KTIcon iconName='cross-circle' className='fs-3' iconType='solid' />

                                    Suspend
                                </button>}
                                {row.status == "1" &&
                                    <button
                                        className="btn btn-light-success btn-sm d-flex align-items-center  px-3 py-2 rounded-pill shadow-sm"
                                        title="Activate User "
                                        onClick={() => changeReportUserStatus('0', row.reportedId, row.reporterName || '', row.reason || '')}
                                    >
                                        <KTIcon iconName='check-circle' iconType='solid' className='fs-3' />

                                        Activate
                                    </button>}
                            </>
                        )}
                        <Link
                            to={getEncryptedRoute('../explore/user/', {
                                menuId: postManagementId,
                                userId: row.reportedId,
                            })}
                            className='btn btn-sm btn-icon btn-light-primary'
                            title='View Reported User'
                        >
                            <KTIcon iconName='eye' className='fs-2' />
                        </Link>

                    </div>
                ),
                width: '180px',
            },
            {
                name: t('Verification Status'),
                cell: (row: any) => (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            justifyContent: 'flex-start',
                            padding: '4px 0', // Reduced padding
                        }}
                    >
                        {row.status == 0 ? (
                            <span
                                className='btn btn-success mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'
                                style={{ marginTop: 0 }}
                            >
                                {t('Active')}
                            </span>
                        ) : row.status == 1 ? (
                            <span
                                className='btn btn-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'
                                style={{ marginTop: 0 }}
                            >
                                {t('Suspended')}
                            </span>

                        ) : (
                            <span
                                className='btn btn-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'
                                style={{ marginTop: 0 }}
                            >
                                {t('N/A')}
                            </span>
                        )}
                    </div>
                ),
                sortable: false,
                filter: true,
                width: '180px',
                selector: (row: any) => String(row.status),
            },
        ],
        [t, menuIdView, menuIdEdit, menuIdDelete, menuId]
    )

    useEffect(() => {
        reportedUserListApiCall()
    }, [limit, offset, sortField, sortOrder, searchTerm])

    useEffect(() => {
        document.title = 'Insayr | Reported Users'
    }, [])

    const handlePageChange = (newPage: number) => {
        try {
            const totalPages = Math.ceil(totalRecords / limit)

            if (newPage === 1) {
                setOffset(0)
            } else if (newPage === totalPages) {
                setOffset((totalPages - 1) * limit)
            } else {
                setOffset((newPage - 1) * limit)
            }
        } catch (error) {
            console.error('Error in page change:', error)
        }
    }

    const handleRowsPerPageChange = (newRowsPerPage: number) => {
        try {
            setLimit(newRowsPerPage)
            setOffset(0)
        } catch (error) {
            console.error('Error in rows per page change:', error)
        }
    }

    return (
        <>


            <ToastContainer />
            {isLoading && <Loader />}

            <DataTable
                columns={column}
                data={reportedUserList}
                pagination
                paginationServer={true}
                onChangePage={handlePageChange}
                paginationTotalRows={totalRecords}
                paginationPerPage={limit}
                onChangeRowsPerPage={handleRowsPerPageChange}
                paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
                sortServer={true}
                onSort={handleSort}
                subHeader={true}
                subHeaderComponent={<CustomHeader search={searchTerm} isfoc={focus} customSearch={reportedUserSearch} />}
                paginationComponentOptions={{
                    rowsPerPageText: t('Rows Per Page'),
                }}
            />
        </>
    )
}

export { ReportedUsers }